import React from 'react';
import PropTypes from 'prop-types';

export default function IndicatorIcon(props) {
  const { fill, size, direction } = props;

  function getRotationAngle(direction) {
    const angles = {
      left: '0',
      right: '180',
      up: '90',
      down: '270'
    };

    return angles[direction] !== undefined ? angles[direction] : '0';
  }

  const rotate = getRotationAngle(direction);

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      transform={`rotate(${rotate})`}
    >
      <g data-name='indicador'>
        <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148844' />
        <path
          fill={fill}
          stroke={fill}
          d='M17.395 9.654h-13.8l4.809-6.043a.683.683 0 0 0-1.069-.849L1.643 9.915c-.006.007-.011.016-.016.024s-.021.03-.03.045-.024.042-.034.064-.015.032-.021.046-.016.05-.024.077a.414.414 0 0 0-.011.043.712.712 0 0 0 0 .252c0 .015.008.029.011.043a.5.5 0 0 0 .024.077.438.438 0 0 0 .021.046c.01.022.022.043.034.064s.02.03.03.045.01.016.016.024l5.692 7.152a.683.683 0 0 0 1.069-.85l-4.809-6.043h13.8a.686.686 0 0 0 0-1.372Z'
          data-name='Caminho 103145'
        />
      </g>
    </svg>
  );
}

IndicatorIcon.defaultProps = {
  size: '20',
  fill: '#66C39B',
  direction: 'left'
};

IndicatorIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string,
  direction: PropTypes.oneOf(['left', 'up', 'right', 'down'])
};
